import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

// import { getSomething } from '../../../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

// FIXME: this props will be needed: layer
const LayerFileTypeField = ({ layerSubType }) => {
  if (LAYER_SUBTYPES.EXTERNAL_SERVER === layerSubType) {
    return (
      <Form.Group>
        <Form.Label>File Type</Form.Label>
        <Form.Control as="select" name="fileType" defaultValue="">
          <option>Shape</option>
        </Form.Control>
      </Form.Group>
    );
  }
  return '';
};
LayerFileTypeField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerFileTypeField;
